export var Size;
(function (Size) {
    Size[Size["Small"] = 1] = "Small";
    Size[Size["Medium"] = 1.5] = "Medium";
    Size[Size["Large"] = 2] = "Large";
})(Size || (Size = {}));
export var Radius;
(function (Radius) {
    Radius[Radius["XXSmall"] = 2] = "XXSmall";
    Radius[Radius["XSmall"] = 4] = "XSmall";
    Radius[Radius["Small"] = 6] = "Small";
    Radius[Radius["Medium"] = 8] = "Medium";
    Radius[Radius["Large"] = 12] = "Large";
    Radius[Radius["XLarge"] = 16] = "XLarge";
})(Radius || (Radius = {}));
//# sourceMappingURL=Border.js.map